import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button, Tooltip } from '@mui/material';
import { WorkerCandidateReadiness, WorkerStatus } from '../../models/worker';

const PROMOTABLE_STATUSES = new Set<WorkerStatus>([
    WorkerStatus.PENDING,
    WorkerStatus.PENDING_APPROVAL,
    WorkerStatus.RESERVE_POOL,
]);

export function CandidatePromotionAction({
    status,
    readiness,
    disabled = false,
    onPromote,
}: {
    status: WorkerStatus;
    readiness?: WorkerCandidateReadiness;
    disabled?: boolean;
    onPromote: () => void;
}) {
    if (!PROMOTABLE_STATUSES.has(status)) return null;

    const isReady = readiness?.isComplete === true;
    const missingFields = readiness?.missingFields ?? [];
    const tooltip = isReady
        ? 'Approve - promote this worker to Candidate'
        : `Complete before approving: ${missingFields.join(', ') || 'required fields missing'}`;

    return (
        <Tooltip title={tooltip}>
            <span>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<CheckCircleIcon />}
                    onClick={onPromote}
                    disabled={disabled || !isReady}
                    sx={{ borderRadius: 999 }}
                >
                    Approve
                </Button>
            </span>
        </Tooltip>
    );
}
